import { QuestionTopChoices } from '../../../../entities/candidate_experience/QuestionTopChoices';
import { Col, Row } from 'reactstrap';
import {
  TopChoices,
  TopChoicesChartType,
} from '../../shared_panels/TopChoices';
import stylesheetExports from '../../../../stylesheets/export.module.scss';
import React from 'react';
import classNames from 'classnames';
import { REPORTING_SECTION_CLASS } from '../../../../utils/pdfHandler';
import { PageBreak } from '../PageBreak';

export function DiscoveryTopChoices(props: { discovery: QuestionTopChoices }) {
  if (props.discovery == null) return null;
  if (props.discovery.top_choices.length === 0) return null;

  return (
    <>
      <PageBreak />
      <Row className={classNames(REPORTING_SECTION_CLASS)}>
        <Col xs='12'>
          <TopChoices
            title='Discovery'
            subtitle={props.discovery.question_text}
            topChoices={props.discovery.top_choices}
            fillColor={stylesheetExports.blue500}
            type={TopChoicesChartType.Bar}
          />
        </Col>
      </Row>
    </>
  );
}
